import { render, staticRenderFns } from "./customerService-stat.vue?vue&type=template&id=4cb38eaa&scoped=true"
import script from "./customerService-stat.vue?vue&type=script&lang=js"
export * from "./customerService-stat.vue?vue&type=script&lang=js"
import style0 from "./customerService-stat.vue?vue&type=style&index=0&id=4cb38eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb38eaa",
  null
  
)

export default component.exports